module.exports = __webpack_public_path__ + "img/battery-slash.2e20a567.svg";